import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as PencilSquareIconSvg } from '../../assets/pencil-square-icon.svg';

export const PencilSquareIcon = (props: Partial<CustomIconComponentProps>) => {
  return <Icon component={PencilSquareIconSvg} {...props} />;
};
